
import { Vue, Component, Prop } from "vue-property-decorator";
import { Portal } from "portal-vue";

@Component({
  components: {
    Portal,
  },
})
export default class ModalContainer extends Vue {
  @Prop({ type: String, default: undefined }) readonly size!: string;
  @Prop({ type: String, default: "modal" }) readonly modalId!: string;
  @Prop({ type: String, default: "" }) readonly contentClass!: string;
  @Prop({ type: String, default: "" }) readonly portal_class!: string;
  window: any;
  created() {
    // @ts-ignore
    // window.Intercom("hide")!;
  }

  handleClickOutside(event: Event): void {
    const modalContent = this.$el.querySelector(".relative.z-20");
    if (modalContent && !modalContent.contains(event.target as Node)) {
      this.$emit("close");
    }
  }

  get containerStyles(): string {
    switch (this.size) {
      case "xs":
        return `p-2 sm:px-4 sm:py-6 ${this.contentClass} customOverFlow`;
      case "sm":
        return `sm:px-10 sm:py-5 ${this.contentClass} customOverFlow`;
      case "md":
        return `sm:p-5 ${this.contentClass}`;
      case "lg2":
        return `sm:p-6 customOverFlow ${this.contentClass}`;
      case "lg3":
        return `customSizeSuggestedModal p-4 sm:px-4 py-6 mb-0 ${this.contentClass}`;
      case "xl":
        return `p-4 sm:pt-6 customOverFlow ${this.contentClass}`;
      case "2xl":
        return `customSize p-4 sm:p-8 pb-2 mb-0 ${this.contentClass}`;
      case "3xl":
        return `customSizeResume p-6 mb-0 ${this.contentClass}`;
        case 'MB':
          return 'customOverFlow';
      default:
        return `p-2 sm:pt-4 sm:p-5 ${this.contentClass}`;
    }
  }

  get maxWidth(): string {
    switch (this.size) {
      case "xl":
        return "sm:max-w-5xl";
      case "lg2":
        return "sm:max-w-5xl";
      case "md":
        return "sm:max-w-3xl";
      case "lg":
        return "sm:max-w-3xl";
      case "lg3":
        return "customMaxWidth";
      case "sm":
        return "sm:max-w-lg";
      case "xs":
        return "sm:max-w-md";
      case "2xl":
        return "flex flex-col justify-center";
      case "7xl":
        return "max-w-7xl";
      case "3xl":
        return "";
      default:
        return "sm:max-w-xl";
    }
  }
}
